<template>
  <div
    class="contact-block panel panel-default sidebar-menu wow fadeInLeft animated mb-1" 
		style="visibility: visible;">
		<div class="panel-heading">
			<h3 class="panel-title">{{ $t('configurator.headings.information') }}</h3>
		</div>
		<div class="panel-body text-widget">
      <div style="display: grid; grid-template-columns: 2fr 3fr;">
        <b>{{ $t('configurator.labels.company') }}:</b> <span>{{  request.company }}</span>
        <b>{{ $t('configurator.labels.exhibition_hall') }}:</b> <span>{{  request.exhibition_hall }}</span>
        <b>{{ $t('configurator.labels.exhibition_booth_number') }}:</b> <span>{{ request.exhibition_booth_number }}</span>
        <b>{{ $t('configurator.labels.booth_package') }}:</b> <span>{{ boothName }}</span>
        <b>{{ $t('configurator.labels.booth_type') }}:</b> <span>{{  $t(boothType.translation_key) }}</span>
        <b>{{ $t('configurator.labels.dimensions') }}:</b> <span>{{ $filters.formatLength(request.booth_width) }} x {{ $filters.formatLength(request.booth_depth) }} m ({{ $filters.formatLength(squareMeter) }} {{ $t("labels.sqm") }})</span>
      </div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '@/store'
import { BOOTH_TYPES } from '@/constants'

const store = useMainStore()
// define props
const props = defineProps({
  request: {
    type: Object,
    required: true
  }
})
// define computed props
const locale = computed(() => store.settings.locale)

const inEnglish = computed(() => {
  return locale.value === 'en'
})

const boothName = computed(() => {
  if (props.request.booth === null) {
    return 'Kein Standpaket ausgewählt'
  }

  return inEnglish.value ? props.request.booth.name_en : props.request.booth.name
})

const boothType = computed(() => {
  const index = BOOTH_TYPES.findIndex((boothType) => boothType.type === props.request.booth_type)

  if (index > -1) {
    return BOOTH_TYPES[index]
  }

  return { translation_key: 'unknown' }
})

const squareMeter = computed(() => {
  return props.request.booth_width * props.request.booth_depth
})
</script>